import { ID_TO_PAGE_MAP_INTL_1 } from 'cohorts/intl_1/constants/pages-map'
import { ID_TO_PAGE_MAP_INTL_1T } from 'cohorts/intl_1t/constants/pages-map'
import { ID_TO_PAGE_MAP_INTL_2 } from 'cohorts/intl_2/constants/pages-map'
import { ID_TO_PAGE_MAP_INTL_2LW } from 'cohorts/intl_2lw/constants/pages-map'
import { ID_TO_PAGE_MAP_INTL_D60 } from 'cohorts/intl_d60/constants/pages-map'
import { ID_TO_PAGE_MAP_INTL_D70 } from 'cohorts/intl_d70/constants/pages-map'
import { ID_TO_PAGE_MAP_INTL_HLWN70 } from 'cohorts/intl_hlwn70/constants/pages-map'
import { ID_TO_PAGE_MAP_INTL_MW } from 'cohorts/intl_mw/constants/pages-map'
import { ID_TO_PAGE_MAP_INTL_3 } from 'cohorts/intl_3/constants/pages-map'
import type { TIdToPageMap } from 'models/common.model'

export const ID_TO_PAGE_MAP: TIdToPageMap = {
  ...ID_TO_PAGE_MAP_INTL_1,
  ...ID_TO_PAGE_MAP_INTL_1T,
  ...ID_TO_PAGE_MAP_INTL_2,
  ...ID_TO_PAGE_MAP_INTL_2LW,
  ...ID_TO_PAGE_MAP_INTL_D60,
  ...ID_TO_PAGE_MAP_INTL_D70,
  ...ID_TO_PAGE_MAP_INTL_HLWN70,
  ...ID_TO_PAGE_MAP_INTL_MW,
  ...ID_TO_PAGE_MAP_INTL_3,
}
